import React, { Component } from 'react'
import { connect } from 'react-redux'
import { actions } from 'react-redux-form/immutable'

import FormContainer from './form-container'

class StudentsNew extends Component {

  componentDidMount() {
    this.props.dispatch(actions.reset('studentState'))
  }

  render() {
    return (
      <FormContainer />
    )
  }
}

export default connect()(StudentsNew)



// WEBPACK FOOTER //
// ./src/containers/Students/new.js